import AnimatedScore from '@/components/AnimatedScore/AnimatedScore'
import { useTheme } from '@/contexts/ThemeContext'
import './BarSet.css'

import type { FC } from 'react'

export interface BarSetProps {
  value: number
  type: string
  style?: React.CSSProperties
}

const BarSet: FC<BarSetProps> = ({ value, type, style }) => {
  const theme = useTheme()

  return (
    <div
      className="bar-set"
      style={{ ...style, gap: `calc(${theme.baseHeight} * 0.1)`, marginTop: `calc(${theme.baseHeight} * 0.1)` }}
    >
      <div className="bar-set-box" style={{ width: `calc(${theme.baseHeight} * 1.2)` }}>
        <AnimatedScore
          value={value}
          className="bar-set-value"
          style={{ color: theme.colors.secondary, fontSize: `calc(${theme.baseHeight} * 0.8)` }}
        />
      </div>
      <span className="bar-set-type" style={{ fontSize: `calc(${theme.baseHeight} * 0.4)` }}>
        {type.toUpperCase()}
      </span>
    </div>
  )
}

export default BarSet
